import pendingIconsSelector from './processing_pending_icons_selector'

export default {
	pendingIconsSelector,
}
